<template>
  <div class="group_4 flex-row">
    <img class="label_2" referrerpolicy="no-referrer" src="@/assets/weixn.png" />
    <div class="text-wrapper_2 flex-col justify-between">
      <span class="text_13">绑定微信</span>
      <span class="text_14">绑定后可通过微信扫码登录，无需输入账号密码</span>
    </div>
    <!-- {{xuserInfo.openid}} -->
    <div v-if="userInfo.LANG || wx.headimgurl" class="text-wrapper_4 flex-row">
      <img class="label_4" referrerpolicy="no-referrer" :src="userInfo.IMG || wx.headimgurl" />
      <span class="text_we">{{ userInfo.NICKNAME || wx.nickname }}</span>

    </div>
    <div  v-if="userInfo.LANG || wx.headimgurl"  class="band flex-row">
      <span class="text_band">已绑定</span>
      <span class="text_16" @click="unband()">解&nbsp;绑</span>
    </div>

    <div v-else class="text-wrapper_3 flex-col" @click="band()">
      <span class="text_15">绑定微信</span>
    </div>


    <a-drawer wrapClassName="drawerEdit" :width="600" :visible="visibleEdit"
      :body-style="{ paddingBottom: '80px', paddingTop: '32px' }" :destroyOnClose="true" :closable="false"
      @close="onClose">
      <span class="back" @click="onClose" style="margin-left: 40px;padding: 8px;box-sizing: border-box;">
        <a-icon type="left" />
        返回
      </span>
      <WechatQr />
    </a-drawer>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import WechatQr from '@/components/UserSettings/wechat/wechatQr'

  import  url from '@/store/url_weixin'
  import {get} from '@/util/request'
  export default {
      data () {
        return {
          visibleEdit:false,
          wx:{}
        }
      },
      components: {
        WechatQr
      },
      computed: {
      ...mapState([
        'userInfo',
        'teacherAdmin'
      ])
    },
   
    async mounted() {
        // this.getwxinfo() // 首次加载取数据库数据
        window.addEventListener('message',  async (event) => {
          console.log(event,11)
          if (event.data.openid) {
             this.getwxinfo(event.data) // 重新绑定，更新页面数据和数据库数据
          }
         
         })
      
      
    },
    methods: {
      ...mapActions([
        'getUpdateTeacherInfo',
        'getUserInfo'
      ]),
   
      async unband() {

        this.$confirm({
          title: '解绑微信后将无法扫码登录',
          content: '解绑后可再次绑定',
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            let result = {
              uid: this.teacherAdmin.uid,
              LANG: null,
              IMG: null,
              NICKNAME:null,
              school_id: this.teacherAdmin.school_id,
            }
            await this.getUpdateTeacherInfo(result)

            sessionStorage.removeItem("wxuserInfo")
            await this.getUserInfo()
      
            this.$message.success('解绑成功')
          },
          onCancel() { },
        })

      },
      async band() {
        this.visibleEdit = true

      },
      onClose () { // 关闭抽屉
        this.visibleEdit = false
      },
      async getwxinfo(wxuserInfo) {
        // 微信绑定
        // 从sessio取参数
        // let wxuserInfo = JSON.parse(sessionStorage.getItem('wxuserInfo'))
        if (wxuserInfo) {
          let wxdata = await get(url.wxUserInfo, { openid: wxuserInfo.openid, access_token: wxuserInfo.access_token, lang: "zh_CN" })
          this.wx= wxdata
          let result = {
              uid: this.teacherAdmin.uid,
              IMG: wxdata.headimgurl,
              NICKNAME:wxdata.nickname,
              LANG:wxuserInfo.unionid,
              school_id: this.teacherAdmin.school_id,
            }
            await this.getUpdateTeacherInfo(result)
            await this.getUserInfo()
            this.visibleEdit = false
             this.$message.success('绑定成功')
        }
      }
    }
  }

</script>

<style scoped>
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}
.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}

.group_4 {
  background-color: rgba(255, 255, 255, 1);
  width: 976px;
  height: 102px;
  border: 1px solid rgba(232, 232, 232, 1);
  justify-content: flex-center;
}

.label_2 {
  width: 40px;
  height: 40px;
  margin: 32px 0 0 40px;
}

.text-wrapper_2 {
  width: 294px;
  height: 40px;
  margin: 32px 0 0 24px;
}

.text_13 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: flex;

}

.text_14 {
  width: 294px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 0.6);
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 21px;
  margin-top: 8px;
}

.text-wrapper_3 {
  background-color: rgba(81, 191, 148, 1);
  border-radius: 23px;
  height: 46px;
  width: 140px;
  margin: 28px 40px 0 398px;
    cursor: pointer
}

.text_15 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: justify;
  white-space: nowrap;
  line-height: 18px;
  margin: 14px 0 0 34px;
}
.text_16 {
  width: 81px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 1);
  font-size: 14px;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 14px;
   cursor: pointer;
  border-radius: 23px;
  height: 40px;
  border: 1px solid rgba(126, 134, 142, 0.16);
  display: flex;
  justify-content: center;
  align-items: Center;
}
.text-wrapper_4 {
    margin: 31px 190px 0 auto;
    float: left;

}
.label_4 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.band{
  position: absolute;
  margin: 31px 40px 0 787px
}
.text_we {
  width: auto;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 0.6);
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 21px;
  margin: 11px 0 0 8px;

}
.text_band{
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 0.6);
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 21px;
  margin: 11px 16px 0 8px;
}
</style>